import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

// หน้าสร้างพนักงาน system role = admin — ไม่มีเมนู/ลิงก์ไหนชี้มา ต้องพิมพ์ URL /setup-admin เอง
// ไม่ต้อง login และสร้างได้ไม่จำกัดจำนวน (ดู backend modules/setupAdmin)
// ใช้ axios ตรง (ไม่ผ่าน utils/functions/api.js) เพื่อแสดง error ในฟอร์มเอง ไม่ให้เด้ง global error dialog
const API = `${process.env.REACT_APP_API_URL}/setup-admin`;

const EMPTY_FORM = {
  firstname: '', lastname: '', username: '', password: '', confirm: '',
};

export default function SetupAdmin() {
  const [form, setForm] = useState(EMPTY_FORM);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [created, setCreated] = useState(null);

  const onChange = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) {
      setError('รหัสผ่านทั้งสองช่องไม่ตรงกัน');
      return;
    }
    setSaving(true);
    try {
      const { confirm, ...payload } = form;
      const { data } = await axios.post(API, payload);
      setCreated(data);
    } catch (err) {
      setError(err?.response?.data?.error?.message || err.message);
    } finally {
      setSaving(false);
    }
  };

  const onCreateAnother = () => {
    setForm(EMPTY_FORM);
    setCreated(null);
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper sx={{ p: 3, width: '100%', maxWidth: 440 }}>
        <Typography variant="h6" fontWeight={700}>สร้างผู้ดูแลระบบ</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          สร้างพนักงานที่มี system role = admin
        </Typography>
        {created ? (
          <Stack spacing={2}>
            <Alert severity="success">
              สร้างผู้ดูแลระบบ <b>{created.username}</b> เรียบร้อยแล้ว
            </Alert>
            <Stack direction="row" spacing={1.5}>
              <Button variant="outlined" fullWidth onClick={onCreateAnother}>
                สร้างเพิ่มอีกคน
              </Button>
              <Button component={RouterLink} to="/auth/login" variant="contained" fullWidth>
                ไปหน้าเข้าสู่ระบบ
              </Button>
            </Stack>
          </Stack>
        ) : (
          <Stack component="form" spacing={1.5} onSubmit={onSubmit}>
            {error && <Alert severity="error">{error}</Alert>}
            <Stack direction="row" spacing={1.5}>
              <TextField label="ชื่อ" size="small" fullWidth required value={form.firstname} onChange={onChange('firstname')} />
              <TextField label="นามสกุล" size="small" fullWidth value={form.lastname} onChange={onChange('lastname')} />
            </Stack>
            <TextField label="Username" size="small" required autoComplete="username" value={form.username} onChange={onChange('username')} />
            <TextField label="รหัสผ่าน" type="password" size="small" required autoComplete="new-password" helperText="อย่างน้อย 6 ตัวอักษร" value={form.password} onChange={onChange('password')} />
            <TextField label="ยืนยันรหัสผ่าน" type="password" size="small" required autoComplete="new-password" value={form.confirm} onChange={onChange('confirm')} />
            <Button type="submit" variant="contained" disabled={saving}>
              {saving ? <CircularProgress size={20} color="inherit" /> : 'สร้างผู้ดูแลระบบ'}
            </Button>
          </Stack>
        )}
      </Paper>
    </Box>
  );
}
